import React, { useState, useEffect, useRef } from "react";
import { QuizButton } from "../../types/GeneralStyles";
import { ResultScreen } from "../Webpage.components";
import QuestionPublicLink from "../../component/PublicLink/PublicLink";

// Component voor de cirkel countdown
const CircularCountdown = ({ seconds, total, size = 40, strokeWidth = 4, color }) => {
  const radius = (size - strokeWidth) / 2;
  const circumference = 2 * Math.PI * radius;
  const progress = seconds / total;
  const offset = circumference * (1 - progress);

  return (
    <svg width={size} height={size} style={{ marginLeft: 8 }}>
      {/* Achtergrondcirkel */}
      <circle
        cx={size / 2}
        cy={size / 2}
        r={radius}
        stroke="#ddd"
        strokeWidth={strokeWidth}
        fill="transparent"
      />
      {/* Voortgangscirkel */}
      <circle
        cx={size / 2}
        cy={size / 2}
        r={radius}
        stroke={color}
        strokeWidth={strokeWidth}
        fill="transparent"
        strokeDasharray={circumference}
        strokeDashoffset={offset}
        strokeLinecap="round"
        transform={`rotate(-90 ${size / 2} ${size / 2})`}
      />
      {/* Tekst met resterende seconden */}
      <text
        x="50%"
        y="50%"
        dominantBaseline="middle"
        textAnchor="middle"
        fontSize={size / 2.5}
        fill={color}
        fontWeight="bold"
      >
        {seconds}
      </text>
    </svg>
  );
};

const QuizButtonAction = ({
  result,
  questions,
  oriQuiz,
  overViewPage,
  enableNavigationButton,
  resetQuiz,
  exitQuiz,
}) => {
  const [timer, setTimer] = useState(null);
  const [autoExecuted, setAutoExecuted] = useState(false);
  const intervalRef = useRef(null);

  // Voer de actie uit op basis van btn_function
  const executeAction = () => {
    switch (result.btn_function) {
      case "reset_quiz":
        if (typeof resetQuiz === "function") {
          resetQuiz(result.results_item_id);
        }
        break;
      case "exit_quiz":
        if (window.self !== window.top) {
          leaveQuiz(true);
        } else if (typeof exitQuiz === "function") {
          exitQuiz(result.results_item_id);
        }
        break;
      case "open_link":
        if (result.btn_function_link) {
          window.open(result.btn_function_link, "_blank");
        }
        break;
      default:
        console.warn("Onbekende btn_function:", result.btn_function);
    }
  };

  // Stuur een bericht naar de parent zodat de iframe kan sluiten
  function leaveQuiz(resultFlag = false) {
    const url = window?.location?.href?.includes("localhost")
      ? "http://localhost:8000/"
      : "https://tools.vrtinnovatie.be/";
    window.parent.postMessage(resultFlag, url);
  }

  // Handmatige klik: stop de timer en voer de actie uit
  const handleClick = () => {
    if (intervalRef.current) {
      clearInterval(intervalRef.current);
    }
    executeAction();
  };

  // Start de timer als time_auto_execute > 0 is
  useEffect(() => {
    if (result.time_auto_execute && Number(result.time_auto_execute) > 0) {
      const initialTime = Number(result.time_auto_execute);
      setTimer(initialTime);
      intervalRef.current = setInterval(() => {
        setTimer((prev) => {
          if (prev <= 1) {
            clearInterval(intervalRef.current);
            return 0;
          }
          return prev - 1;
        });
      }, 1000);
    }
    return () => {
      if (intervalRef.current) {
        clearInterval(intervalRef.current);
      }
    };
  }, [result.time_auto_execute]);

  // Wanneer de timer 0 bereikt, voer de actie uit (na de render)
  useEffect(() => {
    if (timer === 0 && !autoExecuted) {
      setAutoExecuted(true);
      setTimeout(() => {
        executeAction();
      }, 0);
    }
  }, [timer, autoExecuted]);

  // Als de resterende tijd 10 seconden of minder is, tonen we de countdown
  const buttonContent = (
    <>
      {result.button_text}
      {timer !== null && timer <= 10 && timer > 0 && (
        <CircularCountdown
          seconds={timer}
          total={10}
          size={30}
          strokeWidth={3}
          color={result.btn_text_color}
        />
      )}
    </>
  );

  return (
    <ResultScreen
      style={{ marginTop: "10px" }}
      bgColor={result.theme_color}
      bgVisible={overViewPage}
      id={result.results_item_id}
    >
      <QuestionPublicLink
        overViewPage={overViewPage}
        type="result"
        quiz_item_id={result.results_item_id}
      />
      <QuizButton
        className="screenVisible"
        bgColor={result.btn_color}
        txtColor={result.btn_text_color}
        onClick={handleClick}
        style={{
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
        }}
      >
        {buttonContent}
      </QuizButton>
    </ResultScreen>
  );
};

export default QuizButtonAction;
